module.exports = __webpack_public_path__ + "static/media/arrow-back.c2740033.svg";